"use client";
import React, { useState } from "react";
import Button, { ButtonColors } from "@/app/pwa/components/Button";
import { Person } from "@/sources/kicker-amateur/types";
import { UserInfo } from "@/sources/kicker-ovsyndication";
import { UserInquiryModal } from "@/app/pwa/components/modals/UserInquiryModal";
import UserCheck from "@/assets/icon/user-check.svg";
import { apiUserInquiryPath } from "@/utils/urlHelper";
import { useRouter } from "next/navigation";

interface UserInquiryButtonProps {
  person?: Person;
  user: UserInfo;
  color?: ButtonColors;
  teamId?: number;
}

export function UserInquiryButton({ person, user, color, teamId }: UserInquiryButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const router = useRouter();

  const handleSubmit = async (firstName: string, lastName: string, message: string) => {
    const response = await fetch(apiUserInquiryPath(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        personId: person?.Id?.toString(),
        teamId: teamId,
        firstName,
        lastName,
        message,
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to create user inquiry");
    }
    else {
      setIsModalOpen(false);
      router.refresh();
    }
  };

  return (
    <>
      <div className="flex justify-center">
        <Button
          color={color || "secondary"}
          className="inline-flex w-full justify-center max-w-md text-center"
          onClick={() => setIsModalOpen(true)}
        >
          <span>
          {person ? "Das bin ich" : "Vereinsmitglied werden"}
          </span>
          <UserCheck className="button__icon" />
        </Button>
      </div>

      <UserInquiryModal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        person={person}
        user={user}
        onSubmit={handleSubmit}
      />
    </>
  );
} 
